<div class="d-flex flex-column preferences-container">
  <div class="content-header">
    <label>
      {{ 'PREFERENCES_LABEL' | translate }}
    </label>
</div>
<div class="content-body">
  <fieldset>
    <legend>{{ 'RECENTLY_VIEWED_ESTIMATES' | translate }}</legend>
    <mat-dialog-content>
      <form [formGroup]="settingsForm" class="settings-form">
        <div class="row">
          <div class="col-sm-4">
            <label for="estimateDisplay">{{ 'ESTIMATES_DISPLAY' | translate }}</label>
          </div>
          <div class="col-sm-2">
            <mat-form-field appearance="outline">
              <input matInput id="estimateDisplay" type="number" formControlName="estimateDisplay" min="4" max="12">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <label for="favouriteEstimateDisplay">{{ 'FAVOURITE_ESTIMATES_DISPLAY' | translate }}</label>
          </div>
          <div class="col-sm-2">
            <mat-form-field appearance="outline">
              <input matInput id="favouriteEstimateDisplay" type="number" formControlName="favouriteEstimateDisplay" min="0" max="4">
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </fieldset>
  </div>
  <mat-dialog-actions align="end" class="d-flex justify-content-end content-footer">
    <button mat-button color="primary" mat-dialog-close>{{ 'NAVBAR_HELP' | translate }}</button>
    <button mat-button color="primary" type="button" (click)="onSubmit()" (dblclick)="onSubmit()" [mat-dialog-close]>{{ 'COMMON_DIALOGS_BTN_LABELS_OK' | translate }}</button>
    <button mat-button color="warn" mat-dialog-close>{{ 'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate }}</button>
  </mat-dialog-actions>
</div>